module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_06-e48f901749074eda3392d5208db4d8fd.png";